import { render, staticRenderFns } from "./ModuleSelection.vue?vue&type=template&id=a805c6b4&scoped=true&"
import script from "./ModuleSelection.vue?vue&type=script&lang=js&"
export * from "./ModuleSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSelection.vue?vue&type=style&index=0&id=a805c6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a805c6b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})
